class GooglePlacesHelper {

    static extract(component) {

        var result = {};
        var codes = [
            'route',
            "administrative_area_level_2",
            "administrative_area_level_1",
            "country",
            "postal_code",
            "locality",
            "route",
        ];

        for (var i = 0; i < component.length; i++) {
            const expr = component[i].types[0];
            const value = component[i].long_name;
            switch (expr) {
                case "route":
                    result.route = value
                    break;
                case "administrative_area_level_1":
                    result.state = value
                    break;
                case "country":
                    result.country = value
                    break
                case "locality":
                    result.city = value
                    break;
                case "postal_code":
                    result.zip = value
                    break
                case "route":
                    result.route = value
                    break
            }
        }
        return result;
    }

}



export default GooglePlacesHelper


